import React from 'react';
import { Search } from 'lucide-react';
import { Customer } from '../../../types';

interface ContactFiltersProps {
  customers: Customer[];
  selectedCustomerFilter: number | '';
  searchQuery: string;
  onCustomerChange: (value: number | '') => void;
  onRefresh: () => void;
  onSearchChange: (value: string) => void;
}

const ContactFilters: React.FC<ContactFiltersProps> = ({
  customers,
  selectedCustomerFilter,
  searchQuery,
  onCustomerChange,
  onRefresh,
  onSearchChange,
}) => (
  <>
    {/* Filters */}
    <div className="flex flex-wrap gap-2 items-end mb-3">
      <div>
        <label className="block text-sm font-medium mb-0.5 theme-text-primary">Customer</label>
        <select
          className="border border-white  theme-border rounded-lg p-2  focus:outline-none 
         focus:border-blue-500 
  focus:ring-0  theme-bg-primary theme-text-primary"
          value={selectedCustomerFilter}
          onChange={(e) => onCustomerChange(e.target.value ? Number(e.target.value) : '')}
        >
          <option value="">All Customers</option>
          {customers.map((c) => (
            <option key={c.id} value={c.id}>
              {c.item}
            </option>
          ))}
        </select>
      </div>
      <button
        onClick={onRefresh}
        className="px-4 py-2 rounded-lg theme-bg-secondary theme-border hover:opacity-80 transition-colors theme-text-primary custom-button"
      >
        Refresh
      </button>
    </div>

    {/* Search Bar */}
    <div className="mb-3">
      <div className="relative">
        <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 theme-text-tertiary w-4 h-4" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search by name, email, phone, title, customer..."
          className="w-full pl-10 pr-4 py-2 theme-border rounded-lg border border-white  theme-border rounded-lg p-2  focus:outline-none 
         focus:border-blue-500 
  focus:ring-0  theme-bg-primary theme-text-primary  border border-white theme-bg-primary theme-text-primary"
        />
      </div>
    </div>
  </>
);

export default ContactFilters;
